<template>
  <section class="eligibility-tool__start content" aria-labelledby="contextual-offers-dialog-title">
    <h1 id="contextual-offers-dialog-title" ref="screenHeading" class="eligibility-tool__heading eligibility-tool__heading--start" tabindex="-1" data-modal-heading>
      Contextual offer eligibility checker
    </h1>

    <p class="eligibility-tool__lead">
      Answer a few quick questions to find out whether you may qualify. There are 6 questions, and you may get a result before the end.
    </p>

    <p class="eligibility-tool__body">
      This checker gives an indication of your eligibility based on your circumstances and our current criteria, which may change over time. We recommend checking the criteria in the year that you apply. Our Admissions team make the final decision based on your eligibility at the point of application.
    </p>

    <p class="eligibility-tool__body">
      Contextual offers are only available to UK (home fee) students. This typically means that you’ve been ordinarily resident in the UK for at least 3 years, and are eligible for UK tuition fees and student finance.
    </p>

    <button id="contextual-offers-start-button" class="button bg-bright-red eligibility-tool__button eligibility-tool__button--primary" type="button" @click="$emit('start')">
      Get started
    </button>
  </section>
</template>

<script>
export default {
  name: 'TitleScreen',
  mounted() {
    this.$nextTick(() => {
      const modalContent = this.$el.closest('.eligibility-tool__modal-content');
      if (modalContent) modalContent.scrollTo({ top: 0, left: 0 });
      if (this.$refs.screenHeading) this.$refs.screenHeading.focus({ preventScroll: true });
    });
  }
};
</script>
